<div class="dropdown-menu spacey">
  @for (action of actions; track trackByAction($index, action)) {
    @if (action.separator) {
      <div class="dropdown-divider"></div>
    }
    @if (!action.separator) {
      <div>
        <!-- Header -->
        @if (action.isTitle) {
          <div class="dropdown-heading">
            @if (action.icon) {
              <fa-icon [icon]="action.icon"></fa-icon>
            }
            <span>{{ action.label }}</span>
          </div>
        }
        <!-- Link -->
        @if (!action.isTitle) {
          <a class="dropdown-item" (click)="onActionClick(action, $event)">
            <span class="dropdown-item-link-col1">
              <span class="dropdown-item-link-label">
                @if (action.icon) {
                  <fa-icon [icon]="action.icon"></fa-icon>
                }
                <span>{{ action.label }}</span>
              </span>
            </span>
          </a>
        }
      </div>
    }
  }
</div>
